<template>
  <div class="w-full">
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">All Growth Plans</div>
          <p class="text-left m-2 text-white">View All The Growth Plans</p>
          <span class="flex flex-row ">
            <div v-if="!hasSubmitted">
              <lms-button color="#fff" @click="downloadMasterJournal"
                >{{ button.download_text }}
              </lms-button>
              <lms-button
                color="#FEFCBF"
                class="ml-4 "
                @click="handleTutorialLink"
                >{{ "GrowthPlan Tutorial " }}
              </lms-button>
              <lms-button color="#fff"  class="ml-4 "  @click="submitGrowthPlan">{{button.submit_text}} </lms-button>
            </div>
          </span>

          <vue-html2pdf
            :show-layout="false"
            :enable-download="true"
            :preview-modal="false"
            filename="MasterJournal"
            :pdf-quality="2"
            :paginate-elements-by-height="2000"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            ref="html2Pdf"
            @hasGenerated="hasGenerated($event)"
            :htmlToPdfOptions="htmlToPdfOptions"
          >
            <section slot="pdf-content">
              <!-- PDF Content Here -->
              <span class="flex justify-center mt-3 mb-3 "
                ><img :src="landingLogo" width="100" height="100"
              /></span>
              <h1
                class="text-center bold mt-4 mb-4"
                style="text-transform: uppercase"
              >
                <b> {{ tenantCompany }}</b>
              </h1>
              <h2 class="text-center bold mt-4 mb-4">
                <b> MASTER GROWTH PLAN PDF</b>
              </h2>

              <div v-for="(plan, index) in planResponses" :key="index">
                <page-header class="text-bold mt-4">{{
                  plan.title
                }}</page-header>
                <div
                  class="w-full flex flex-wrap"
                  v-for="(question, index) in plan.response"
                  :key="index"
                >
                  <div class="flex w-full flex-wrap justify-between">
                    <h2
                      v-html="question.question"
                      class="py-2 uppercase main-tenant-color "
                    ></h2>
                  </div>
                  <div class="my-4 w-full md:w-1/2">
                    <main class="mx-2">
                      <p>Answer : <span v-html="question.answer"></span></p>
                    </main>
                  </div>
                </div>
              </div>
            </section>
          </vue-html2pdf>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <div class="">
      <!--<lCrumbs :breadcrumb="breadcrumbItems" />-->
    </div>
    <div class="mx-8 mt-4">
      <linput
        v-model="search"
        class="py-2"
        placeholder="Search by Growth Plan Title"
      />
    </div>
    <div class="block sm:flex sm:justify-even sm:flex-wrap">
      <growth-card
        v-for="plan in searchGrowthPlan"
        :key="plan.id"
        :data="plan"
        :course="plan.course_id"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Empty from "../../../components/general/Empty";
import VueHtml2pdf from "vue-html2pdf";

import FormActions from "@/mixins/FormActions";
import SettingsMixin from "@/mixins/SettingsMixin";
//import note from "../../../components/general/note";
export default {
  mixins: [SettingsMixin, FormActions],
  components: {
    Empty,
    lcontainer: () => import("@/components/general/container"),
    GrowthCard: () => import("@/components/learner/growthCard"),
    LmsButton: () => import("@/components/general/button"),
    VueHtml2pdf,
    ltextarea: () => import("@/components/general/textarea"),
    PageHeader: () => import("@/components/general/pageheader"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    linput: () => import("@/components/general/input")
  },
  data() {
    return {
      courses:{},
      search: "",
      boards: [],
      loading: true,
      masterGrowthPlan: "",
      growthplans: [],
      planResponses: [],
      submitResponses: [],
      finalSubmitResponses: [],
      reviewSubmitResponses: [],
      hasSubmitted: false,
      button: {
        download_text: "Download Master GrowthPlan",
        submit_text: "Submit All Growth Plans"
      },
      htmlToPdfOptions: {
        margin: 0.5,

        filename: `MasterGrowthPlan.pdf`,

        image: {
          type: "png",
          quality: 0.98
        },

        enableLinks: true,

        html2canvas: {
          scale: 1,
          useCORS: true
        }
      },
      count_compulsory: 10,
      count_elective: 8,
      LMSUserItem: JSON.parse(localStorage.getItem("lms-user")),
      coursesCountCompulsory: 0,
      coursesCountElectives: 0,
      hasCompletedAllCourses: false,
      checkCompletedCoursesMessage: 'You have not completed your courses'
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions([
      "LearnerFetchCourseGrowthPlans",
      "fetchSingleLearnerCourse",
      "LearnerShowGrowthPlanResponse",
      "learnerFetchGrowthPlanCourses"
    ]),
    handleTutorialLink() {
      window.open(
        "https://edc-learn-videos.s3-eu-west-1.amazonaws.com/EDCLearn+Growth+Plan+Appendix.pdf",
        "_blank"
      );
    },
    async downloadMasterJournal() {
      this.button.download_text = "Downloading....";
      let complete_response = false;
      for (let plan of this.growthplans) {
        let response = plan.responses;
        if (response !== null && response.length > 0) {
          try {
            this.planResponses.push({
              title: plan.title,
              response: response
            });
            complete_response = true;
          } catch (e) {
            // this.$Bus.$emit("notify", {
            //     type: "error",
            //     message: 'An Error Occured while trying to compile some of the growthplan  responses'
            // });
            continue;
          } finally {
          }
        }
      }
      if (!this.planResponses.length > 0) {
        this.$Bus.$emit("notify", {
          type: "error",
          message: "No Active Responses"
        });
        this.button.download_text = "Download Master Journal";
      }
      if (complete_response) {
        this.$refs.html2Pdf.generatePdf();
      }

    },
    async submitGrowthPlan() {
      this.button.submit_text = "Compiling....";
      let complete_response = false;
      let isComplete = true;
      for (let plan of this.growthplans) {
        if (plan.completed === "Incomplete" && plan.title !== null) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: "Please Attempt All Growth Plans Before Submission"
          });
          isComplete = false;
          break;
        }
        let response = [];
        for (let res of plan.responses) {
          res.course_id = plan.course_id;
          response.push(res);
        }
        if (response !== null && response.length > 0) {
          try {
            this.submitResponses.push(response);
            complete_response = true;
          } catch (e) {
            // this.$Bus.$emit("notify", {
            //     type: "error",
            //     message: 'An Error Occured while trying to compile some of the growthplan  responses'
            // });
          } finally {
          }
        }
      }
      if (isComplete) {
        //console.log(this.submitResponses)
        dance: for (let responses of this.submitResponses) {
          // console.log(responses)
          for (let response of responses) {
            if ( typeof response.answer !== "undefined" && response.answer !== null && response.answer !== "" ) {
              this.reviewSubmitResponses.push(response);
              if ( response.reg_question_id !== null && typeof response.reg_question_id !== "undefined" ) {
                this.finalSubmitResponses.push({
                  question: response.title,
                  answer: response.answer,
                  question_id: response.reg_question_id
                });
              }
            } else if (1==2) { // add condition for incomplete courses
              this.$Bus.$emit("notify", {
                type: "error",
                message:
                  "Please Ensure You Have Answered All Questions  Before Submission"
              });
              isComplete = false;
              break dance;
            } else {
              this.$Bus.$emit("notify", {
                type: "error",
                message:
                  "Please Ensure You Have Answered All Questions  Before Submission"
              });
              isComplete = false;
              break dance;
            }
          }
        }
      }

      //   this.$modal.show("review");
      //   this.$Bus.$emit('review',{
      //     review:this.reviewSubmitResponses
      //   })

      if (isComplete) {
        //console.log(this.finalSubmitResponses)
        //console.log(this.reviewSubmitResponses)
        let data = [this.finalSubmitResponses, this.reviewSubmitResponses];

        localStorage.setItem("review_" + this.getUser.id, JSON.stringify(data));

        await this.$router.push({ name: "learner-growthplan-review" });
      }

      this.button.submit_text = "Submit All Growth Plans";

    },
    hasGenerated() {
      this.button.download_text = "Download Master Journal";
    },
    hide() {
      this.$modal.hide("review");
    },
    async checkCompletedCourses() {
      this.updateLoader(true)
      try {
          const res = await Object.values(this.getSubscribedCourses);
          this.courses = res;
          //console.log(res)
          let completedElectives = [];
          let completedCompulsory = [];
          this.courses.forEach((item) => {
            //console.log(item);
              if(item.course_level === 'elective') {                      
                if (item.progress >= 100 && !item.title.toLowerCase().includes("survey")) {
                  completedElectives.push(item);
                }
              }
              if(item.course_level === 'compulsory') {
                if (item.progress >= 100 && !item.title.toLowerCase().includes("survey")) {
                  completedCompulsory.push(item);
                }   
              }
          })
	
        let allCoursesCompleted = false;

        let message = '';

         if (this.LMSUserItem.default_program === "5a1113d6-3924-41e6-b815-daad0bc005e1") {
         // For the special program without electives

         allCoursesCompleted = completedCompulsory.length >= this.count_compulsory;

        if (completedCompulsory.length < this.count_compulsory) {
             message += `You have <b>${this.count_compulsory - completedCompulsory.length}</b> compulsory courses left to complete.<br>`;
            }
        } else {

        // Default logic for other programs
        allCoursesCompleted = completedCompulsory.length >= this.count_compulsory && completedElectives.length >= this.count_elective;

        if (completedCompulsory.length < this.count_compulsory) {
           message += `You have <b>${this.count_compulsory - completedCompulsory.length}</b> compulsory courses left to complete.<br>`;
        }
        if (completedElectives.length < this.count_elective) {
            message += `You have <b>${this.count_elective - completedElectives.length}</b> elective courses left to complete.<br>`;
           }
        }

        if (allCoursesCompleted) {
	    message += 'You have completed all your required courses! Ensure you fill and submit your Growth Plans!';
        } else {
	   message += 'Please kindly complete your courses.';
        }


          // console.log(this.count_compulsory)
          // console.log(this.count_elective)
          // console.log(completedCompulsory)
          // console.log(completedElectives)
          
//          if (completedCompulsory.length >= this.count_compulsory) {
//            this.completedCompulsoryCourses = true;
//          }

//          if (completedElectives.length >= this.count_elective) {
//            this.completedElectivesCourses = true;
//          }
  
//          let data = {
//              completedElectives: completedElectives.length,
//              completedCompulsory: completedCompulsory.length,
//          };

//        let message = '';
        
//        let compare_elective = this.count_elective;

        //update what count_compulsory and count_elective is here for non TNY
//        if (this.LMSUserItem.default_program != "4f1b9237-da53-4812-be86-841bee6a8971") {
//          this.count_compulsory = this.coursesCountCompulsory;
//          this.count_elective = this.coursesCountElectives;
//        }


//        if (data.completedCompulsory < this.count_compulsory) {
//          message += 'You have  <b>' + (this.count_compulsory - parseInt(data.completedCompulsory)) + '</b>  courses left to complete your compulsory courses <br> ';
//        }

//        if (this.count_elective > 0 && data.completedElectives < compare_elective) {
//          message += 'You have  <b>' + (compare_elective - parseInt(data.completedElectives)) + '</b>  courses left to complete your elective courses <br> ';
//        }
            
//        if ((this.count_elective == 0 && data.completedCompulsory >= this.count_compulsory) || (this.count_elective > 0 && (data.completedCompulsory >= this.count_compulsory && data.completedElectives >= compare_elective) )) {
//          this.hasCompletedAllCourses = true;
//          message += 'You have completed all your required courses! Ensure you fill and submit your Growth Plans!';
//        }


//        if (data.completedCompulsory >= this.count_compulsory && data.completedElectives >= compare_elective){


//        } else {


//        }


        //console.log(message);
	this.hasCompletedAllCourses = allCoursesCompleted;
        this.checkCompletedCoursesMessage = message;

        // console.log(this.coursesCountCompulsory)
        // console.log(this.coursesCountElectives)

        //console.log(this.checkCompletedCoursesMessage);
        this.updateLoader(false)
      } catch (e) {
          this.updateLoader(false)
      }
    },
  },
  computed: {
    ...mapGetters(["getLearnerCourse", "getCoursesGrowthPlans", "getUser", "getSubscribedCourses"]),
    breadcrumbItems() {
      return [
        {
          disabled: true,
          to: "/learner/growth_plan",
          text: "Growth Plan  Categrories"
        },
        {
          disabled: true,
          to: "#",
          text: `${this.getLearnerCourse.title}`
        }
      ];
    },

    searchGrowthPlan() {
      return this.growthplans.filter(plan => {
        if (plan.title !== null) {
          return plan.title.toLowerCase().match(this.search.toLowerCase());
        }
      });
    }
  },

  async mounted() {
    this.updateLoader(true);
    let res = await this.learnerFetchGrowthPlanCourses();
    let growthplancourses = [];

    for (let plans of res.data.data.growth_plans) {
      if (plans.title !== null || typeof plans !== "undefined") {
        if (plans.completed === "completed") {
          this.hasSubmitted = true;
        }
        this.growthplans.push(plans);
      }
    }
    // GET {{baseUrl}}/tenant/growth_plan/learner/course-list/show
    //console.log(res.data);
    //console.log(this.growthplans);

    //Assess Course Progress
    //await this.checkCompletedCourses();
    //console.log(this.LMSUserItem) 

    this.loading = false;
    this.updateLoader(false);

    // if (course.status === 500) {
    //     this.$router.go(-1);
    //     this.$Bus.$emit('notify', {
    //         type: "error",
    //         message: "The Course Could not be found",
    //     })
    // }

    // this.notes.forEach(note => {
    //     this.masterNote += "<p><br/><br/></p>"
    //     this.masterNote += `<h3 style="text-transform: uppercase;"><b>[ ${note.course.title} ] </b></h3>`
    //     this.masterNote += "<p><br/></p>"
    //     this.masterNote += note.note
    //     this.masterNote += "<p><br/></p>"
    //
    // })
  }
};
</script>

<style scoped></style>
